import React from "react";
import { I18nextProvider } from "react-i18next";
import { BaseSavedSearch, Category } from "../model/model";
import { EditSavedSearchModal } from "./EditSavedSearchModal";
import { SavedSearchProvider } from "./SavedSearchProvider";
import { i18n } from "../locales/i18next";

export interface Props {
  isOpen: boolean;
  closeModal: () => void;
  savedSearchId: number;
  category: Category;
  onSave?: (savedSearch: BaseSavedSearch) => void;
  onDelete?: (id: number) => void;
}

export const EditSavedSearchModalContainer = ({
  isOpen,
  closeModal,
  savedSearchId,
  category,
  onSave,
  onDelete,
}: Props) => (
  <I18nextProvider i18n={i18n}>
    <SavedSearchProvider
      isOpen={isOpen}
      closeModal={closeModal}
      savedSearchId={savedSearchId}
      category={category}
    >
      {(
        savedSearch: BaseSavedSearch,
        isSettingsModalOpen: boolean,
        closeSettingsModal: () => void
      ) => (
        <EditSavedSearchModal
          isOpen={isSettingsModalOpen}
          closeModal={closeSettingsModal}
          search={savedSearch}
          category={category}
          onSave={onSave}
          onDelete={onDelete}
        />
      )}
    </SavedSearchProvider>
  </I18nextProvider>
);
